<div class="project-container">
  <app-card>
    <form id="projectsForm" [formGroup]="projectsForm">
      <div class="title">
        <span class="header-title">{{ 'project_data' | translate }}</span>
        <div style="display: flex; gap: 20px;">
          <button *ngIf="this.projects && (this.projects.length > 0)" mat-icon-button (click)="toggleProjects()"
            type="button">
            <mat-icon *ngIf="!isEnabled" svgIcon="expand_more"></mat-icon>
            <mat-icon *ngIf="isEnabled" svgIcon="expand_less"></mat-icon>
          </button>
          <button
              *ngIf="isConsult && backendProjects.controls.length > 1"
              mat-mini-fab
              [matTooltip]="getSortTooltipLabel()"
              matTooltipPosition="above"
              matTooltipClass="info-tooltip-content"
              class="sort-icon-button"
              onclick="this.blur()"
              (click)="sortByDate()"
            >
              <mat-icon svgIcon="sort"></mat-icon>
          </button>
        </div>
      </div>
      <div class="action-block">
        <button mat-button type="button" color="secondary" (click)="openNewProjectDialog()">
          {{ 'add_new_project' | translate }}
          <mat-icon style="margin-top: 25px;" iconPositionStart>add</mat-icon>
        </button>
        <button *ngIf="this.projects && (this.projects.length > 0)" id="btn-save" class="save-button" mat-button
          (click)="submit()" [disabled]="projectsForm.invalid || isProjectsSaving">
          {{ 'save_projects_data_label' | translate }}
        </button>
      </div>
      <section class="errors-block">
        <mat-error *ngIf="projectsForm.invalid && !projectsForm.pristine && projects.length > 0">
          {{ 'there_are_mandatory_fields' | translate }}
        </mat-error>
      </section>
      <div>
        <div *ngIf="backendProjects && backendProjects.length > 0">
          <div formArrayName="backendProjects">
            <mat-accordion class="projects-accordion" multi cdkDropList [cdkDropListDisabled]="!isConsult || backendProjects.controls.length < 2">
              <div *ngFor="let control of backendProjects.controls; index as i" class="project-panel"
                style="display: flex;" [formGroupName]="i" cdkDrag (cdkDragDropped)="itemDropped($event)">
                <div class="custom-drag-placeholder" *cdkDragPlaceholder></div>
                <div *cdkDragPreview>
                  <div *ngIf="isConsult" class="action-buttons-block">
                    <div class="action-buttons">
                      <img class="cursor-move"
                          src="assets/icons/drag_handle.svg"
                          *ngIf="isConsult && backendProjects.controls.length > 1"
                          cdkDragHandle>
                      <img class="cursor-pointer"
                          src="assets/icons/visibility.svg"
                          *ngIf="isSelected(i)">
                      <img class="cursor-pointer"
                          src="assets/icons/visibility_off.svg"
                          *ngIf="!isSelected(i)">
                    </div>
                    <div class="project-deselected">
                      <span *ngIf="!isSelected(i) && isConsult">{{'project_deselected' | translate}}</span>
                    </div>
                  </div>

                  <div class="expansion-panel-project-name">
                    <mat-form-field style="width: auto;" appearance="outline" color="secondary">
                      <input matInput placeholder="{{ 'project_name' | translate }}"
                        [ngClass]="{'inActive': !isSelected(i)}" type="text"
                        class="form-control" maxlength="70" formControlName="name" name="project_name" required>
                    </mat-form-field>
                    <button mat-mini-fab color="primary" class="icon-button" type="button">
                      <mat-icon svgIcon="delete"></mat-icon>
                    </button>
                  </div>
                </div>
                <mat-expansion-panel class="project-expansion-panel" [expanded]="!isConsult">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="action-buttons-block">
                        <div class="action-buttons" *ngIf="isConsult">
                          <img class="cursor-move"
                              src="assets/icons/drag_handle.svg"
                              *ngIf="isConsult && backendProjects.controls.length > 1"
                              cdkDragHandle>
                          <img class="cursor-pointer"
                              src="assets/icons/visibility.svg"
                              *ngIf="isSelected(i)"
                              (click)="$event.stopPropagation(); handleSelect(i)">
                          <img class="cursor-pointer"
                              src="assets/icons/visibility_off.svg"
                              *ngIf="!isSelected(i)"
                              (click)="$event.stopPropagation(); handleSelect(i)">
                        </div>
                        <div class="project-deselected" *ngIf="isConsult">
                          <span *ngIf="!isSelected(i) && isConsult">{{'project_deselected' | translate}}</span>
                        </div>
                      </div>

                      <div class="expansion-panel-project-name">
                        <input id="id" type="hidden" formControlName="id" name="id">
                        <input type="hidden" formControlName="selected">
                        <mat-form-field style="width: auto;" appearance="outline" color="secondary">
                          <input
                            matInput
                            placeholder="{{ 'project_name' | translate }}"
                            [ngClass]="{'inActive': !isSelected(i)}"
                            type="text"
                            pattern="^(\s+\S+\s*)*(?!\s).*$"
                            maxlength="70"
                            formControlName="name"
                            name="project_name"
                            autocomplete="off"
                            required
                            (click)="$event.stopPropagation()"
                            (keydown.Space)="$event.stopPropagation()">
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').errors?.maxlength">
                            {{ 'err_msg_maxlength' | translate: {'number': 70} }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').touched && this.backendProjects.controls[i].get('name').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').errors?.pattern">
                            {{ 'err_msg_please_fill' | translate }}
                          </mat-error>
                        </mat-form-field>
                        <button mat-mini-fab color="primary" class="icon-button"
                          (click)="$event.stopPropagation(); removeProject(i, control.controls.id.value)" type="button">
                          <mat-icon svgIcon="delete"></mat-icon>
                        </button>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="project-card">
                    <div class="project-card-header">
                      <div class="head-data">
                        <input id="id" type="hidden" formControlName="id" name="id">
                        <input type="hidden" formControlName="selected">
                        <mat-form-field style="width: auto;" appearance="outline" color="secondary">
                          <input matInput placeholder="{{ 'project_name' | translate }}"
                            [ngClass]="{'inActive': !isSelected(i)}" type="text" pattern="^(\s+\S+\s*)*(?!\s).*$"
                            maxlength="70" formControlName="name" name="project_name"
                            autocomplete="off" required>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').errors?.maxlength">
                            {{ 'err_msg_maxlength' | translate: {'number': 70} }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').touched && this.backendProjects.controls[i].get('name').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('name').errors?.pattern">
                            {{ 'err_msg_please_fill' | translate }}
                          </mat-error>
                        </mat-form-field>
                        <button mat-mini-fab color="primary" class="icon-button"
                          (click)="removeProject(i, control.controls.id.value)" type="button">
                          <mat-icon svgIcon="delete"></mat-icon>
                        </button>
                      </div>
                      <div class="main-data">
                        <mat-form-field style="width: auto;" appearance="outline" class="disable-error-color">
                          <mat-select formControlName="projectApproach"
                            placeholder="{{ 'project_approach' | translate }}" required>
                            <mat-option *ngFor="let approach of projectApproaches" [value]="approach">
                              {{'project_approaches.' + approach | translate}}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('projectApproach').touched && this.backendProjects.controls[i].get('projectApproach').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field style="width: auto;" appearance="outline" class="disable-error-color">
                          <mat-select formControlName="type" placeholder="{{ 'project_type' | translate }}" required>
                            <mat-option *ngFor="let key of getProjectTypeKeys()" [value]="key">
                              {{('project_types.' + key) | translate}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('type').touched && this.backendProjects.controls[i].get('type').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field style="width: auto;" appearance="outline" class="disable-error-color">
                          <mat-select formControlName="branch" placeholder="{{ 'branch' | translate }}" required [compareWith]="compareById">
                            <mat-option *ngFor="let branch of branches" [value]="branch">
                              {{translate.currentLang === 'en' ? branch.nameEn : branch.name }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('branch').touched && this.backendProjects.controls[i].get('branch').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field style="width: auto;" appearance="outline" color="secondary">
                          <input matInput placeholder="{{ 'customer' | translate }}" id="customer" type="text"
                            pattern="^(\s+\S+\s*)*(?!\s).*$" maxlength="40" formControlName="customer" name="customer"
                            autocomplete="off" required>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('customer').errors?.maxlength">
                            {{ 'err_msg_maxlength' | translate: {'number': 40} }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('customer').touched && this.backendProjects.controls[i].get('customer').errors?.required">
                            {{ 'required' | translate }}
                          </mat-error>
                          <mat-error *ngIf="this.backendProjects.controls[i].get('customer').errors?.pattern">
                            {{ 'err_msg_please_fill' | translate }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div formArrayName="roles" *ngIf="allRoles">
                        <label class="ng-multiselect-label" for="role">{{ 'role_in_proj' | translate }}</label>
                        <ng-multiselect-dropdown [name]="i+1" [placeholder]="'select_role'|translate"
                          [settings]="dropdownSettings" [data]="allRoles"
                          [formControl]="backendProjects.controls[i].get('roles')"
                          (onSelect)="onRoleSelect($event, control.controls.id.value)"
                          (onDeSelect)="onRoleDeSelect($event, control.controls.id.value)">
                        </ng-multiselect-dropdown>
                        <small
                          *ngIf="!backendProjects.controls[i].get('roles')?.pristine && backendProjects.controls[i].get('roles').invalid"
                          class="form-text text-error text-right">
                          {{ 'required' | translate }}
                        </small>
                      </div>
                    </div>

                    <div class="show-details">
                      <span>{{'project_details' | translate}}</span>
                      <hr>
                      <button mat-icon-button (click)="toggleProjectDetails(control.controls.id.value)" type="button">
                        <mat-icon *ngIf="!showDetails(control.controls.id.value)" svgIcon="expand_more"></mat-icon>
                        <mat-icon *ngIf="showDetails(control.controls.id.value)" svgIcon="expand_less"></mat-icon>
                      </button>
                    </div>

                    <div *ngIf="showDetails(control.controls.id.value)" class="project-details">
                      <div class="quill-editor">
                        <div class="title">
                          <label for="projDescription">{{'project_description' | translate}}</label>
                        </div>
                        <quill-editor id="projDescription" class="content-editor quill-editor" [modules]="modules"
                          placeholder='' formControlName="description"
                          (onEditorCreated)='editorInit($event)'>
                        </quill-editor>
                        <span
                          class="counter"
                          [matTooltip]="'counter_tip_label' | translate"
                          matTooltipPosition="below"
                          matTooltipClass="info-tooltip-content">
                          {{control.controls.description.value?.length || 0}} / 600
                        </span>
                        <div class="errors">
                          <span *ngIf="backendProjects.controls[i].get('description').errors?.maxlength"
                            class="form-text text-error text-center">
                            {{ 'err_msg_maxlength' | translate: {'number': 600} }}
                          </span>
                          <span
                            *ngIf="backendProjects.controls[i].get('description').touched && backendProjects.controls[i].get('description').errors?.required"
                            class="form-text text-error text-right">
                            {{ 'required' | translate }}
                          </span>
                          <span *ngIf="backendProjects.controls[i].get('description').errors?.pattern"
                            class="form-text text-error text-center">
                            {{ 'err_msg_please_fill' | translate }}
                          </span>
                        </div>
                      </div>
                      <div class="quill-editor">

                        <div class="title">
                          <label for="taskDescription">{{'tasks_description' | translate}}</label>
                        </div>
                        <quill-editor id="taskDescription" class="content-editor quill-editor"
                          [modules]="{ toolbar: [ { 'list': 'bullet' }] }" placeholder=''
                          formControlName="taskDescription" [style]="editorStyle"
                          (onEditorCreated)='editorInit($event)'></quill-editor>
                          <span
                            class="counter"
                            [matTooltip]="'counter_tip_label' | translate"
                            matTooltipPosition="below"
                            matTooltipClass="info-tooltip-content">
                            {{control.controls.taskDescription.value?.length || 0}} / 1200
                          </span>
                        <div class="errors">
                          <span *ngIf="backendProjects.controls[i].get('taskDescription').errors?.maxlength"
                            class="form-text text-error text-center">
                            {{ 'err_msg_maxlength' | translate: {'number': 1200} }}
                          </span>
                          <span
                            *ngIf="backendProjects.controls[i].get('taskDescription').touched && backendProjects.controls[i].get('taskDescription').errors?.required"
                            class="form-text text-error text-right">
                            {{ 'required' | translate }}
                          </span>
                          <span *ngIf="backendProjects.controls[i].get('taskDescription').errors?.pattern"
                            class="form-text text-error text-center">
                            {{ 'err_msg_please_fill' | translate }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div class="quill-editor">
                          <div class="title">
                            <label for="highlight">{{'highlights' | translate}}</label>
                          </div>
                          <quill-editor id="highlight" class="content-editor quill-editor"
                            [modules]="{ toolbar: [ { 'list': 'bullet' }] }" placeholder='' formControlName="highlight"
                            required="true" [style]="editorStyle" (onEditorCreated)='editorInit($event)'></quill-editor>
                            <span
                              class="counter"
                              [matTooltip]="'counter_tip_label' | translate"
                              matTooltipPosition="below"
                              matTooltipClass="info-tooltip-content">
                              {{control.controls.highlight.value?.length || 0}} / 500
                            </span>
                          <div class="errors">
                            <span *ngIf="backendProjects.controls[i].get('highlight').errors?.maxlength"
                              class="form-text text-error text-center">
                              {{ 'err_msg_maxlength' | translate: {'number': 500} }}
                            </span>
                            <span
                              *ngIf="backendProjects.controls[i].get('highlight').touched && backendProjects.controls[i].get('highlight').errors?.required"
                              class="form-text text-error text-right">
                              {{ 'required' | translate }}
                            </span>
                            <span *ngIf="backendProjects.controls[i].get('highlight').errors?.pattern"
                              class="form-text text-error text-center">
                              {{ 'err_msg_please_fill' | translate }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="techno-div">
                        <div class="duration-row">
                          <mat-form-field style="width: auto;" appearance="outline">
                            <input matInput placeholder="{{ 'project_start' | translate }}"
                              formControlName="startDate" [matDatepicker]="startDatePicker" required>
                            <mat-datepicker-toggle matIconSuffix [for]="startDatePicker">
                              <mat-icon matDatepickerToggleIcon svgIcon="calendar_month"></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                            <mat-error *ngIf="this.backendProjects.controls[i].get('startDate').touched && this.backendProjects.controls[i].get('startDate').errors?.required">
                              {{ 'required' | translate }}
                            </mat-error>
                          </mat-form-field>
                          <mat-form-field style="width: auto;" appearance="outline">
                            <input matInput placeholder="{{ 'project_end' | translate }}"
                              formControlName="endDate" [matDatepicker]="endDatePicker" required>
                            <mat-datepicker-toggle matIconSuffix [for]="endDatePicker">
                              <mat-icon matDatepickerToggleIcon svgIcon="calendar_month"></mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                            <mat-error *ngIf="this.backendProjects.controls[i].get('endDate').touched && this.backendProjects.controls[i].get('endDate').errors?.required">
                              {{ 'required' | translate }}
                            </mat-error>
                          </mat-form-field>
                          <mat-form-field style="width: auto;" appearance="outline">
                            <input matInput placeholder="{{ 'duration' | translate }}" disabled
                              value="{{this.getDuration(backendProjects.controls[i].get('startDate').value, backendProjects.controls[i].get('endDate').value)}}">
                          </mat-form-field>
                        </div>
                        <small *ngIf="backendProjects.controls[i].get('startDate').value &&
                                                backendProjects.controls[i].get('endDate').value &&
                                                !checkDates(backendProjects.controls[i].get('startDate').value,
                                                            backendProjects.controls[i].get('endDate').value)"
                          class="form-text text-error ml-4 w-50 text-right date">
                          {{ 'endDate_must_be_later' | translate }}
                        </small>
                        <div *ngIf="allTechnologies">
                          <label class="ng-multiselect-label">{{ 'technologies' | translate }}</label>
                          <ng-multiselect-dropdown [ngClass]="{'upper-position': i >= backendProjects.length - 2}"
                            [name]="i" [placeholder]="'select_technology'|translate" [settings]="dropdownSettings"
                            [data]="allTechnologies" [formControl]="backendProjects.controls[i].get('technologies')"
                            (onSelect)="onTechnologySelect($event, control.controls.id.value)"
                            (onDeSelect)="onTechnologyDeSelect($event, control.controls.id.value)">
                          </ng-multiselect-dropdown>
                          <small
                            *ngIf="!backendProjects.controls[i].get('technologies')?.pristine && backendProjects.controls[i].get('technologies').invalid"
                            class="form-text text-error text-right">
                            {{ 'required' | translate }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                </mat-expansion-panel>
              </div>
            </mat-accordion>
          </div>
        </div>
      </div>
    </form>
  </app-card>
</div>
